export type ShippingMethodType = keyof typeof shippingMethodCodes;

export const shippingMethodCodes = {
    inpost: 'flatrate',
    dhlPoland: 'dhlpoland',
    dhlWorldwide: 'dhlworldwide',
    dhlPickUpPoint: 'dhlpop',
    dhlCashOnDelivery: 'dhlcashondelivery',
    pharmalink: 'pharmalink',
    fxcouriers: 'fxcouriers',
    dpdCashOnDelivery: 'dpdcashondelivery',
    dpdPoland: 'dpd',
    dpdPickUpPoint: 'dpdpop',
};

export const listingMainCategoryVariantB = {
    featureFlag: 'listing-main-category-variant-b',
    categoryUrlKey: 'version-b',
};

export const alternativeProductSkuPostfix = '_dm';
export const multipackProductSkuSufix = '_multipack_';
export const internalStoreCategory = 'internal-store-category';
